import type { FormFieldHandle } from "../../components/forms/types";

export function scrollToField(field: FormFieldHandle | null) {
  field?.scrollToElement({
    behavior: "smooth",
    block: "center",
  });
}

export function scrollToElement(element: HTMLElement | null | undefined) {
  element?.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });
}
